<div
  class="modal now-modal fade {{ additionalModalClasses }}"
  id="{{ modalId }}"
  tabindex="-1"
  role="dialog"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="'modal-title-' + modalId"
>
  <div class="modal-dialog now-modal-dialog modal-dialog-centered">
    <div class="modal-content now-modal-content">
      <div class="modal-header now-modal-header {{ additionalHeaderClasses }}">
        <h2 class="modal-title now-modal-title h4" id="modal-title-{{ modalId }}">
          {{ modalTitle }}
        </h2>
        <button
          type="button"
          class="now-btn now-btn-tertiary now-btn-icon-only now-icon-x"
          data-bs-dismiss="modal"
          aria-label="Modaldialog schließen"
          title="Modaldialog schließen"
        ></button>
      </div>
      <div class="modal-body now-modal-body" [class.text-center]="center">
        <ng-content></ng-content>
      </div>
      @if (secondaryButtonText || primaryButtonText) {
        <div class="modal-footer now-modal-footer">
          @if (primaryButtonText && primaryBeforeSecondary) {
            <button
              class="now-btn now-btn-primary"
              type="button"
              [attr.aria-label]="primaryButtonText"
              data-bs-dismiss="modal"
              (click)="primaryButtonClick.emit(true)"
            >
              {{ primaryButtonText }}
            </button>
          }
          @if (secondaryButtonText) {
            <button
              class="now-btn now-btn-secondary"
              type="button"
              [attr.aria-label]="secondaryButtonText"
              data-bs-dismiss="modal"
              (click)="secondaryButtonClick.emit(true)"
            >
              {{ secondaryButtonText }}
            </button>
          }
          @if (primaryButtonText && !primaryBeforeSecondary) {
            <button
              class="now-btn now-btn-primary"
              type="button"
              [attr.aria-label]="primaryButtonText"
              data-bs-dismiss="modal"
              (click)="primaryButtonClick.emit(true)"
            >
              {{ primaryButtonText }}
            </button>
          }
        </div>
      }
    </div>
  </div>
</div>
